module.exports = __webpack_public_path__ + "../resources/images/emptyFlaggedEmailTaskList-b942d79f1f3bb9c584552450f4aa6118.svg";